import React from "react";
import styles from "./MedicalTravel.module.css";
import MedicalTravelPattern from "../../../../components/UI/MedicalTravelPattern";
import useDeviceWidth from "../../../../components/device-width/UseDeviceWidth";
import MedicalTravelPatternTab from "../../../../components/UI/MedicalTravelPatternTab";
import MedicalTravelPatternMob from "../../../../components/UI/MedicalTravelPatternMob";
import { useNavigate } from "react-router-dom";

const MedicalTravel = ({ data }) => {
  const width = useDeviceWidth();
  const navigate = useNavigate();

  return (
    <section className={styles.section}>
      {/* <img
        className={styles.pattern}
        src="https://via.placeholder.com/1200x800/000000/333333?text=Pattern"
        alt="Pattern"
      /> */}
      {width > 1200 ? (
        <MedicalTravelPattern className={styles.pattern} />
      ) : width > 768 ? (
        <MedicalTravelPatternTab className={styles.pattern} />
      ) : (
        <MedicalTravelPatternMob className={styles.pattern} />
      )}
      <div className={styles.container}>
        {width > 1200 && (
          <div className={styles.imageWrapper}>
            <img
              data-aos="fade-down"
              data-aos-delay="150"
              className={styles.mainImage}
              src={data?.listingItems[0]?.images[0]?.url}
              alt={data?.listingItems[0]?.images[0]?.imageTag}
            />
          </div>
        )}
        <div className={styles.content}>
          {data?.showTitle && (
            <div className={styles.title}>
              <div
                dangerouslySetInnerHTML={{ __html: data?.title }}
                data-aos="fade-right"
                data-aos-delay="150"
              ></div>
            </div>
          )}
          <h2
            data-aos="fade-right"
            data-aos-delay="150"
            className={styles.subtitle}
          >
            {data?.subTitle}
          </h2>
          {width <= 1200 && (
            <div className={styles.imageWrapper}>
              <img
                data-aos="fade-down"
                data-aos-delay="150"
                className={styles.mainImage}
                src={data?.listingItems[0]?.images[0]?.url}
                alt={data?.listingItems[0]?.images[0]?.imageTag}
              />
            </div>
          )}
          <div
            data-aos="fade-right"
            data-aos-delay="150"
            className={styles.description}
            dangerouslySetInnerHTML={{
              __html: data?.listingItems[0]?.homeDescription,
            }}
          />
          <button
            data-aos="fade-down"
            data-aos-delay="150"
            onClick={() => navigate(`/pages/${data?.listingItems[0]?.slug}`)}
            className={`${styles.button} bg-primary-500 primary-hover2 border-primary-500`}
          >
            Know More
          </button>
        </div>
      </div>
    </section>
  );
};

export default MedicalTravel;
